import {createContext, useContext, useState} from "react";
import {AuthContext} from "./authContext";
import {API_BASE_URL, API_KEY} from "../config/config";
import axios from "axios";

const WidgetContext = createContext(null);

const WidgetProvider = ({ children }) => {
	const {visitor} = useContext(AuthContext);

	const [widgetsLoading, setWidgetsLoading] = useState(false);
	const [widgetsHtmlData, setWidgetsData] = useState({
		forum_overview_members_online: null,
		forum_overview_new_posts: null,
		forum_overview_forum_statistics: null,
		tag_cloud: null
	});

	const fetchWidgetHtml = async (widgetKey) => {
		if (!visitor) return;

		if (widgetsHtmlData[widgetKey] !== null) return; // Already loaded

		if (widgetsLoading) return; // Loading

		try {
			setWidgetsLoading(true);

			const apiUrl = `${API_BASE_URL}/widgets/${widgetKey}/render`

			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: apiUrl,
				headers: {
					'XF-Api-Key': API_KEY,
					'XF-Api-User': visitor.user_id,
				},
				withCredentials : true
			};

			const response = await axios.request(config);
			const html = response.data.html;

			setWidgetsData((prevData) => ({
				...prevData,
				[widgetKey]: html ? html : '',
			}));

			setWidgetsLoading(false);
		} catch (error) {
			console.error('Failed to fetch widget:', error);
			setWidgetsLoading(false);
		}
	}

	return (
		<WidgetContext.Provider value={{
			...widgetsHtmlData,
			fetchWidgetHtml,
		}}>
			{children}
		</WidgetContext.Provider>
	)
}

export { WidgetContext, WidgetProvider };